import { render } from "./ThePublications.vue?vue&type=template&id=d85900e4"
import script from "./ThePublications.vue?vue&type=script&lang=js"
export * from "./ThePublications.vue?vue&type=script&lang=js"

import exportComponent from "/home/cyrill/Projects/kmapper/repos/cyrill.codeberg.page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__